import type { TradeItem } from "modules/tradeLists/model/tradeList";

type TradeItemTransitionKeyShape = Pick<
  TradeItem,
  | "anyPrinting"
  | "condition"
  | "dataId"
  | "finishes"
  | "language"
  | "list"
  | "oracleId"
  | "user"
>;

/**
 * Stable visual identity for one grouped trade row.
 *
 * Concrete IDs remain the canonical React and mutation identity, but their set
 * changes whenever quantity changes. This mirrors the backend browse grouping
 * so an authoritative refetch can still transition the same visual row.
 */
export function tradeItemTransitionKey(
  item: TradeItemTransitionKeyShape
): string {
  const anyPrinting = item.anyPrinting;
  return JSON.stringify([
    item.user.id,
    item.list.id,
    anyPrinting ? item.oracleId || item.dataId : item.dataId,
    item.condition,
    anyPrinting ? "" : item.language,
    anyPrinting ? [] : item.finishes,
    anyPrinting,
  ]);
}
